import type { VideoDraftDto } from "../api/videoService";

/**
 * VID-UX-1(2026-08-18):「关页回来自动续看」的语义补全。
 *
 * 横幅承诺的「回来」此前只在**从草稿箱点回那份草稿**时成立 —— 重进「新建视频」是白纸,
 * 用户以为编排丢了。修法=创建页空载时检测该用户有**在途编排/出图**的草稿,给一条
 * 「继续上次的编排」恢复入口(listDrafts 服务端已按 租户+当前用户 双钥过滤,前端不再放宽)。
 */

/** 在途 = 服务端 Job 还在跑的三态(与 VideoCreatePage 恢复路的续轮询判据同一组)。 */
const IN_FLIGHT = new Set(["COMPOSING", "GENERATING", "RUNNING"]);

/**
 * 挑「该提示继续的那份」:在途 + 没提交过出片(consumedTaskId 非空 = 已提交,
 * 那单的进度在任务详情页,不在创建页)→ 取最近更新的一份。没有 → null(不出横幅)。
 */
export function pickResumableDraft(
  drafts: VideoDraftDto[] | null | undefined
): VideoDraftDto | null {
  const inFlight = (drafts ?? []).filter(
    (d) => IN_FLIGHT.has(d.frameGenStatus ?? "") && d.consumedTaskId == null
  );
  if (inFlight.length === 0) return null;
  return [...inFlight].sort((a, b) =>
    (b.updatedAt ?? b.createdAt ?? "").localeCompare(a.updatedAt ?? a.createdAt ?? "")
  )[0];
}
